import { useQuery } from '@tanstack/react-query'

import { chatKeys } from '../../keys'
import chatService from '../services'

export const useQueryAiSetting = () => {
	return useQuery({
		queryKey: chatKeys.aiSetting(),
		queryFn: () => chatService.getAiSetting(),
		staleTime: 60 * 1000,
	})
}
